const ar = {
  // Header
  'search': 'بحث...',
  'scan': 'مسح',
  'profile': 'الملف الشخصي',
  'settings': 'الإعدادات',
  'logout': 'تسجيل الخروج',
  'admin': 'المدير',
  'administrator': 'مدير النظام',
  'admin.email': 'admin@admin.com',

  // Navbar
  'nav.dashboard': 'لوحة القيادة',
  'nav.products': 'المنتجات',
  'nav.variants': 'المتغيرات',
  'nav.invoices': 'الفواتير',
  'nav.clients': 'العملاء',

  // Login
  'login.welcome': 'مرحبا',
  'login.title': 'تسجيل الدخول',
  'login.subtitle': 'الوصول إلى لوحة القيادة',
  'login.username': 'اسم المستخدم',
  'login.username.placeholder': 'أدخل اسم المستخدم',
  'login.password': 'كلمة المرور',
  'login.password.forgot': 'نسيت كلمة المرور؟',
  'login.password.placeholder': 'أدخل كلمة المرور',
  'login.remember': 'تذكرني',
  'login.connecting': 'جاري الاتصال...',
  'login.signin': 'تسجيل الدخول',
  'login.or': 'أو المتابعة باستخدام',
  'login.no.account': 'ليس لديك حساب؟',
  'login.signup': 'إنشاء حساب',
  'login.success': 'تم تسجيل الدخول بنجاح!',
  'login.error': 'معلومات غير صحيحة!',
  'login.error.generic': 'خطأ في تسجيل الدخول!',

  // Dashboard
  'dashboard.title': 'لوحة قيادة المخزون',
  'dashboard.subtitle': 'إدارة ومراقبة منتجات المخزون',
  'dashboard.high_stock': 'المنتجات عالية المخزون',

  //Dates select 
  'date.today': "اليوم",
  'date.this_month': "هذا الشهر",
  'date.last_30_days': "آخر 30 يوم",
  'date.last_6_months': "آخر 6 أشهر",
  'date.last_12_months': "آخر 12 شهر",
  'date.all_period': "كل الفترة",
  'date.custom_period': "فترة مخصصة",
  'date.select_period': "اختر فترة",
  'date.cancel': "إلغاء",
  'date.apply': "تطبيق",
  'date.months_short': ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  'date.months_long': ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  'date.days_short': ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],

  // Invoices
  'invoices.title': 'فواتير العملاء',
  'invoices.subtitle': 'إنشاء الفواتير وحفظها وطباعتها مع تحديث المخزون',
  'invoices.new_invoice': 'فاتورة جديدة',
  'invoices.client_name': 'اسم العميل',
  'invoices.client_name.placeholder': 'أدخل اسم العميل',
  'invoices.invoice_code': 'رمز الفاتورة',
  'invoices.remove_payment_confirm': 'تأكيد حذف الدفع',
  'invoices.invoice_code.placeholder': 'أدخل رمز الفاتورة',
  'invoices.logo': 'الشعار',
  'invoices.search_product': 'بحث عن منتج',
  'invoices.no_products_found': 'لم يتم العثور على منتجات',
  'invoices.product': 'المنتج',
  'invoices.variant': 'النسخة',
  'invoices.quantity': 'الكمية',
  'invoices.unit_price': 'سعر الوحدة',
  'invoices.line_total': 'إجمالي',
  'invoices.add_item': 'إضافة عنصر',
  'invoices.remove_item': 'حذف',
  'invoices.subtotal': 'المجموع الفرعي',
  'invoices.remise': 'الخصم',
  'invoices.total': 'الإجمالي',
  'invoices.save': 'حفظ الفاتورة',
  'invoices.saving': 'جاري الحفظ...',
  'invoices.saved': 'تم حفظ الفاتورة بنجاح',
  'invoices.print': 'طباعة الفاتورة',
  'invoices.preview_title': 'معاينة الفاتورة',
  'invoices.preview_description': 'راجع الفاتورة قبل طباعتها أو مشاركتها.',
  'invoices.saved_invoice': 'الفاتورة المحفوظة',
  'invoices.select_product': 'اختر المنتج',
  'invoices.select_variant': 'اختر النسخة',
  'invoices.no_variant': 'لا توجد نسخ متاحة',
  'invoices.product_price': 'سعر المنتج الافتراضي',
  'invoices.items_count': 'العناصر',
  'invoices.error.loading_products': 'تعذر تحميل المنتجات',
  'invoices.error.validation': 'يرجى تصحيح أخطاء النموذج',
  'invoices.error.print': 'يتعذر فتح مربع حوار الطباعة. يرجى تمكين النوافذ المنبثقة أو المحاولة مرة أخرى.',
  'invoices.error.general': 'حدث خطأ أثناء حفظ الفاتورة',
  'invoices.scan_barcode': 'مسح الباركود',
  'invoices.scan_barcode_placeholder': 'امسح أو أدخل الباركود...',
  'invoices.barcode_not_found': 'المنتج غير موجود لهذا الباركود',
  'invoices.item_added': 'تمت الإضافة للفاتورة',
  'invoices.scan_now': 'مسح الآن',
  'invoices.items_added': 'تمت إضافة العناصر للفاتورة',
  'invoices.scan_title': 'ماسح الفاتورة',
  'invoices.scan_subtitle': 'امسح المنتجات لإضافتها للفاتورة',
  'invoices.scan_now_placeholder': 'امسح أو أدخل الباركود الآن...',
  'invoices.scanned_items': 'العناصر الممسوحة',
  'invoices.add_all_to_invoice': 'إضافة الكل',
  'invoices.stock': 'المخزون',
  'invoices.add_to_invoice': 'إضافة',
  'invoices.scan_ready': 'جاهز للمسح',
  'invoices.scan_ready_desc': 'استخدم قارئ الباركود أو أدخل الباركود يدوياً لإضافة المنتجات لهذه الفاتورة.',
  'invoices.scan_footer': 'وضع مسح الفاتورة',
  'invoices.product_found': 'تم العثور على المنتج',
  'invoices.recently_added': 'تمت الإضافة مؤخراً',
  'invoices.items_added_success': 'تمت الإضافة بنجاح',
  'invoices.items_waiting': 'عنصر(عناصر) في الانتظار',
  'invoices.validation.client_name': 'اسم العميل مطلوب',
  'invoices.validation.invoice_code': 'رمز الفاتورة مطلوب',
  'invoices.invoice_code.draft': 'سيتم إنشاء رمز تلقائياً',
  'invoices.validation.product': 'يلزم اختيار المنتج أو الاسم',
  'invoices.validation.variant_required': 'يرجى اختيار نسخة لهذا المنتج',
  'invoices.validation.quantity': 'يجب أن تكون الكمية 1 على الأقل',
  'invoices.client_phone': 'هاتف العميل',
  'invoices.client_phone.placeholder': 'أدخل هاتف العميل',
  'invoices.status': 'الحالة',
  'invoices.status.not_yet': 'غير مدفوع',
  'invoices.status.regle': 'مدفوع',
  'invoices.client_history.title': 'سجل العميل',
  'invoices.client_history.total_invoiced': 'إجمالي الفواتير',
  'invoices.client_history.total_paid': 'إجمالي المدفوع',
  'invoices.client_history.balance': 'الرصيد',
  'invoices.client_history.invoices': 'الفواتير',
  'invoices.client_history.payments': 'المدفوعات',
  'invoices.client_history.no_invoices': 'لا توجد فواتير',
  'invoices.client_history.no_payments': 'لا توجد مدفوعات',
  'invoices.client_history.payment_amount': 'مبلغ الدفع',
  'invoices.client_history.payment_date': 'تاريخ الدفع',
  'invoices.client_history.payment_note': 'ملاحظة',
  'clients.title': 'حسابات العملاء',
  'clients.subtitle': 'راجع فواتير العملاء والمبالغ غير المدفوعة والمدفوعات وأضف مدفوعات جديدة.',
  'clients.total_clients': 'إجمالي العملاء',
  'clients.client_list': 'قائمة العملاء',
  'clients.search_placeholder': 'البحث بالاسم أو الهاتف...',
  'clients.name': 'الاسم',
  'clients.phone': 'الهاتف',
  'clients.invoices': 'الفواتير',
  'clients.total_invoiced': 'إجمالي الفواتير',
  'clients.balance': 'الرصيد',
  'clients.view_history': 'عرض السجل',
  'clients.loading': 'جاري تحميل العملاء...',
  'clients.no_clients': 'لم يتم العثور على عملاء',
  'clients.client_history_title': 'سجل العميل',
  'clients.client_history_description': 'راجع جميع الفواتير والمدفوعات والرصيد المستحق للعميل المحدد.',
  'clients.total_paid': 'إجمالي المدفوع',
  'clients.unpaid_amount': 'المبلغ غير المدفوع',
  'clients.invoice_list_description': 'فواتير هذا العميل مع تفاصيل المدفوعات والرصيد.',
  'clients.invoice_code': 'رمز الفاتورة',
  'clients.status': 'الحالة',
  'clients.total': 'الإجمالي',
  'clients.paid': 'المدفوع',
  'clients.select_invoice': 'اختر الفاتورة للدفع',
  'clients.add_payment': 'إضافة دفع',
  'clients.payment_form_title': 'تسجيل دفعة',
  'clients.payment_form_description': 'أضف دفعة لفاتورة مستحقة.',
  'clients.payment_invoice': 'الفاتورة',
  'clients.payment_amount': 'مبلغ الدفع',
  'clients.payment_note': 'ملاحظة',
  'clients.payment_note_placeholder': 'ملاحظة اختيارية لهذه الدفعة',
  'clients.payment_submit': 'حفظ الدفع',
  'clients.payment_saving': 'جاري حفظ الدفع...',
  'clients.payment.success': 'تم تسجيل الدفع بنجاح',
  'clients.error.loading': 'يتعذر تحميل العملاء',
  'clients.error.loading_details': 'يتعذر تحميل تفاصيل العميل',
  'clients.error.payment': 'يتعذر تسجيل الدفع',
  'clients.error.payment_amount': 'أدخل مبلغ دفع صالح',
  'clients.payments': 'المدفوعات',
  'clients.no_payments': 'لا توجد مدفوعات',
  'clients.no_invoices': 'لم يتم العثور على فواتير',
  'clients.bulk_payment_title': 'دفعة جماعية',
  'clients.bulk_payment_description': 'توزيع الدفعة على جميع الفواتير غير المدفوعة (الأقدم أولاً)',
  'clients.bulk_payment_amount': 'إجمالي مبلغ الدفعة',
  'clients.bulk_payment_submit': 'توزيع الدفعة',
  'clients.bulk_payment_saving': 'جاري التوزيع...',
  'clients.bulk_payment_success': 'تم توزيع الدفعة بنجاح',
  'clients.bulk_payment_preview': 'معاينة التوزيع',
  'clients.bulk_payment_no_unpaid': 'لا توجد فواتير غير مدفوعة للتوزيع',
  'clients.transaction_history': 'سجل المعاملات',
  'clients.invoice': 'فاتورة',
  'clients.payment': 'دفعة',
  'clients.unpaid_invoices': 'الفواتير غير المدفوعة',
  'clients.no_transactions': 'لم يتم العثور على معاملات',
  'dashboard.low_stock': 'المنتجات منخفضة المخزون',
  'dashboard.stock_distribution': 'توزيع المخزون',
  'dashboard.in_stock': 'متوفر',
  'dashboard.low_stock_label': 'مخزون منخفض',
  'dashboard.out_of_stock': 'نفد من المخزون',
  'dashboard.product_types': 'أنواع المنتجات',
  'dashboard.financial_title': 'الملخص المالي',
  'dashboard.total_sales': 'إجمالي المبيعات',
  'dashboard.purchase_cost': 'تكلفة الشراء',
  'dashboard.total_payments': 'إجمالي المدفوعات',
  'dashboard.total_charges': 'المصروفات',
  'dashboard.profit': 'الربح الإجمالي',
  'dashboard.profit_exact': 'صافي الربح',
  'dashboard.with_variants': 'مع متغيرات',
  'dashboard.without_variants': 'بدون متغيرات',

  // Charts
  'charts.daily_profit': 'صافي الربح اليومي',
  'charts.invoice_count': 'عدد الفواتير',
  'charts.total': 'المجموع',
  'charts.invoices': 'فواتير',
  'charts.no_data': 'لا توجد بيانات',

  // StatsMonths
  'stats.total_products': 'إجمالي المنتجات',
  'stats.low_stock_items': 'عناصر المخزون المنخفض',
  'stats.out_of_stock': 'نفد من المخزون',
  'stats.stock_value': 'قيمة المخزون',
  'stats.monitor': 'مراقبة',

  // CardHome
  'card.no_products': 'لا توجد منتجات بعد',
  'card.no_products_desc': 'أضف منتجك الأول لرؤيته هنا',
  'card.no_image': 'لا توجد صورة',
  'card.stock': 'المخزون:',
  'card.price': 'السعر',
  'card.last_updated': 'آخر تحديث',

  // Products page
  'products.title': 'المنتجات',
  'products.subtitle': 'إدارة المخزون ومستويات التخزين',
  'products.add': 'إضافة منتج',
  'products.sync': 'مزامنة',
  'products.syncing': 'جاري المزامنة...',
  'products.sync.title': 'مزامنة المنتجات',
  'products.sync.confirm': 'سيتم مزامنة جميع المنتجات من المصدر الخارجي. هل تريد الاستمرار؟',
  'products.sync.start': 'بدء المزامنة',
  'products.all_status': 'جميع الحالات',
  'products.in_stock': 'متوفر',
  'products.low_stock': 'مخزون منخفض',
  'products.out_of_stock': 'نفد من المخزون',
  'products.search': 'البحث بالاسم أو الوصف...',
  'products.table.product': 'المنتج',
  'products.table.price': 'السعر',
  'products.table.stock': 'المخزون',
  'products.table.variants': 'المتغيرات',
  'products.table.status': 'الحالة',
  'products.table.actions': 'الإجراءات',
  'products.pagination.previous': 'السابق',
  'products.pagination.next': 'التالي',
  'products.pagination.showing': 'عرض',
  'products.pagination.of': 'من',
  'products.pagination.to': 'إلى',
  'products.pagination.products': 'منتجات',
  'products.empty.title': 'لم يتم العثور على منتجات',
  'products.empty.desc': 'ابدأ بإضافة منتجك الأول',
  'products.empty.add': 'إضافة منتجات',
  'products.delete.title': 'حذف المنتج',
  'products.delete.warning': 'لا يمكن التراجع عن هذا الإجراء',
  'products.delete.confirm': 'هل أنت متأكد من حذف',
  'products.delete.variant_warning': 'سيؤدي هذا أيضًا إلى حذف',
  'products.delete.variant_count': 'متغير (متغيرات) مرتبطة.',
  'products.delete.cancel': 'إلغاء',
  'products.delete.deleting': 'جاري الحذف...',
  'products.delete.confirm_btn': 'حذف المنتج',
  'products.fetch.error': 'فشل في جلب المنتجات',
  'products.delete.success': 'تم حذف المنتج بنجاح',
  'products.stock.title': 'زيادة المخزون',
  'products.stock.current': 'المخزون الحالي',
  'products.stock.augment': 'زيادة',
  'products.stock.success': 'تم زيادة المخزون بنجاح',
  'products.stock.error': 'فشل في زيادة المخزون',
  'products.stock.no_variant_qty': 'أضف كمية متغير واحد على الأقل',

  // Variants page
  'variants.title': 'متغيرات المنتج',
  'variants.subtitle': 'إدارة جميع متغيرات المنتج مع الألوان والأحجام والأسعار',
  'variants.add': 'إضافة متغير',
  'variants.table.name': 'الاسم',
  'variants.table.value': 'القيمة',
  'variants.table.type': 'النوع',
  'variants.table.actions': 'الإجراءات',
  'variants.empty.title': 'لم يتم العثور على متغيرات',
  'variants.empty.desc': 'ابدأ بإضافة أول متغير',
  'variants.empty.add': 'إضافة متغير',
  'variants.modal.add.title': 'إضافة متغير جديد',
  'variants.modal.add.desc': 'اختر نوع المتغير وأدخل التفاصيل',
  'variants.modal.select_type': 'اختر نوع المتغير',
  'variants.modal.color': 'لون',
  'variants.modal.size': 'مقاس',
  'variants.modal.color_name': 'اسم اللون',
  'variants.modal.hex': 'رمز اللون السداسي',
  'variants.modal.hex_or_picker': 'أدخل الرمز السداسي أو استخدم منتقي الألوان',
  'variants.modal.size_label': 'المقاس',
  'variants.modal.size_desc': 'سيتم استخدام المقاس لكل من الاسم والقيمة',
  'variants.modal.cancel': 'إلغاء',
  'variants.modal.adding': 'جاري الإضافة...',
  'variants.modal.add_variant': 'إضافة متغير',
  'variants.modal.edit.title': 'تعديل المتغير',
  'variants.modal.edit.desc': 'تحديث تفاصيل المتغير',
  'variants.modal.edit.variant_type': 'نوع المتغير',
  'variants.modal.edit.update': 'تحديث المتغير',
  'variants.modal.edit.updating': 'جاري التحديث...',
  'variants.modal.delete.title': 'حذف المتغير',
  'variants.modal.delete.warning': 'لا يمكن التراجع عن هذا الإجراء',
  'variants.modal.delete.confirm': 'هل أنت متأكد من حذف المتغير',
  'variants.modal.delete.variant_name': '؟',
  'variants.modal.delete.association': 'قد يكون هذا المتغير مرتبطًا بمنتجات. حذفه سيزيل هذه الارتباطات.',
  'variants.modal.delete.deleting': 'جاري الحذف...',
  'variants.modal.delete.confirm_btn': 'حذف المتغير',
  'variants.pagination.previous': 'السابق',
  'variants.pagination.next': 'التالي',
  'variants.pagination.showing': 'عرض',
  'variants.pagination.of': 'من',
  'variants.fetch.error': 'فشل في جلب المتغيرات',
  'variants.add.success': 'تمت إضافة المتغير بنجاح!',
  'variants.update.success': 'تم تحديث المتغير بنجاح!',
  'variants.delete.success': 'تم حذف المتغير بنجاح!',
  'variants.add.error': 'فشل في إضافة المتغير',
  'variants.update.error': 'فشل في تحديث المتغير',
  'variants.delete.error': 'فشل في حذف المتغير',
  'variants.fill.fields': 'يرجى ملء جميع الحقول',

  // StockScanner
  'scanner.title': 'ماسح المخزون',
  'scanner.subtitle': 'امسح أو أدخل الرمز الشريطي',
  'scanner.placeholder': 'أدخل الرمز الشريطي...',
  'scanner.ready': 'جاهز للمسح',
  'scanner.ready_desc': 'استخدم قارئ الباركود أو أدخل يدويًا لتقليل المخزون.',
  'scanner.footer': 'نظام إدارة المخزون v1.3',
  'scanner.new_stock': 'المخزون الجديد:',
  'scanner.last_scan': 'آخر مسح ناجح',
  'scanner.variant': 'المتغير:',
  'scanner.pcs': 'قطعة',
  'scanner.scan_error': 'فشل مسح الباركود',

  // AddProduct
  'product.add.title': 'إضافة منتج جديد',
  'product.add.desc': 'إنشاء منتج جديد',
  'product.add.name': 'اسم المنتج *',
  'product.add.name.placeholder': 'أدخل اسم المنتج',
  'product.add.price': 'السعر *',
  'product.add.purchase_price': 'سعر الشراء *',
  'product.add.quantity': 'الكمية الإجمالية *',
  'product.add.quantity.placeholder': 'أدخل الكمية',
  'product.add.image': 'صورة المنتج',
  'product.add.upload': 'رفع صورة',
  'product.add.recommended': 'موصى به: 500x500 بكسل، JPG، PNG، GIF',
  'product.add.has_variants': 'هذا المنتج له متغيرات (لون، مقاس، إلخ)',
  'product.add.variants_stock': 'سيكون لكل متغير مخزونه الخاص',
  'product.add.no_variants_stock': 'سيكون للمنتج كمية إجمالية واحدة',
  'product.add.variant_type': 'نوع المتغير',
  'product.add.colors_only': 'الألوان فقط',
  'product.add.sizes_only': 'المقاسات فقط',
  'product.add.colors_sizes': 'الألوان والمقاسات',
  'product.add.select_color': 'اختر اللون',
  'product.add.select_size': 'اختر المقاس',
  'product.add.add_combination': 'إضافة مجموعة',
  'product.add.add_color': 'إضافة لون',
  'product.add.add_size': 'إضافة مقاس',
  'product.add.cancel': 'إلغاء',
  'product.add.creating': 'جاري الإنشاء...',
  'product.add.create': 'إنشاء المنتج',
  'product.add.fill_fields': 'يرجى ملء الحقول المطلوبة',
  'product.add.add_variant': 'يرجى إضافة متغير واحد على الأقل',
  'product.add.enter_qty': 'يرجى إدخال الكمية',
  'product.add.no_combinations': 'لم تتم إضافة أي مجموعات',
  'product.add.no_combinations_desc': 'أضف مجموعات الألوان والمقاسات لإنشاء متغيرات منتج مختلفة. سيكون لكل مجموعة مخزونها الخاص.',
  'product.add.combination': 'مجموعة',
  'product.add.stock_qty': 'كمية المخزون *',
  'product.add.total_summary': 'ملخص المخزون الإجمالي',
  'product.add.across': 'عبر جميع المجموعات',
  'product.add.total_units': 'إجمالي الوحدات',
  'product.add.select_color_error': 'يرجى اختيار لون',
  'product.add.select_size_error': 'يرجى اختيار مقاس',
  'product.add.select_both_error': 'يرجى اختيار اللون والمقاس',
  'product.add.color_exists': 'هذا اللون موجود بالفعل',
  'product.add.size_exists': 'هذا المقاس موجود بالفعل',
  'product.add.combination_exists': 'هذه المجموعة موجودة بالفعل',
  'product.add.success': 'تم إنشاء المنتج بنجاح!',
  'product.add.operation_failed': 'فشلت العملية',
  'product.add.load_variants_error': 'فشل تحميل المتغيرات',
  'product.add.enter_stock': 'أدخل المخزون',

  // EditProduct
  'product.edit.title': 'تعديل المنتج',
  'product.edit.desc': 'تحديث تفاصيل المنتج',
  'product.edit.name': 'اسم المنتج *',
  'product.edit.name.placeholder': 'أدخل اسم المنتج',
  'product.edit.price': 'السعر *',
  'product.edit.purchase_price': 'سعر الشراء *',
  'product.edit.quantity': 'الكمية الإجمالية *',
  'product.edit.quantity.placeholder': 'أدخل الكمية',
  'product.edit.image': 'صورة المنتج',
  'product.edit.upload': 'رفع صورة',
  'product.edit.recommended': 'موصى به: 500x500 بكسل، JPG، PNG، GIF',
  'product.edit.has_variants': 'هذا المنتج له متغيرات (لون، مقاس، إلخ)',
  'product.edit.variants_stock': 'سيكون لكل متغير مخزونه الخاص',
  'product.edit.no_variants_stock': 'سيكون للمنتج كمية إجمالية واحدة',
  'product.edit.variant_type': 'نوع المتغير',
  'product.edit.colors_only': 'الألوان فقط',
  'product.edit.sizes_only': 'المقاسات فقط',
  'product.edit.colors_sizes': 'الألوان والمقاسات',
  'product.edit.select_color': 'اختر اللون',
  'product.edit.select_size': 'اختر المقاس',
  'product.edit.add_combination': 'إضافة مجموعة',
  'product.edit.add_color': 'إضافة لون',
  'product.edit.add_size': 'إضافة مقاس',
  'product.edit.cancel': 'إلغاء',
  'product.edit.updating': 'جاري التحديث...',
  'product.edit.update': 'تحديث المنتج',
  'product.edit.success': 'تم تحديث المنتج بنجاح!',

  // TrTableProducts
  'table.no_variants': 'لا توجد متغيرات',
  'table.has_variants': 'يوجد متغيرات',
  'table.no_image': 'لا توجد صورة',
  'table.in_stock': 'في المخزون',
  'table.cost': 'التكلفة:',
  'table.selling_price': 'سعر البيع:',
  'table.cost_price': 'سعر الشراء:',
  'table.margin': 'الهامش:',
  'table.pricing': 'التسعير',
  'table.color_size': 'اللون / المقاس',
  'table.color': 'لون',
  'table.size': 'مقاس',
  'table.stock': 'المخزون',
  'table.no_data': 'لا توجد بيانات متغيرات',
  'table.close': 'إغلاق',
  'table.augment_stock': 'زيادة المخزون',
  'table.view_variants': 'عرض المتغيرات',
  'table.print_stickers': 'طباعة ملصقات QR',
  'table.edit_product': 'تعديل المنتج',
  'table.delete_product': 'حذف المنتج',
  'table.total_stock': 'إجمالي المخزون:',
  'table.units': 'وحدات',
  'table.pcs': 'قطعة',
  'table.more': 'المزيد',
  'table.variant': 'متغير',
  'table.variants': 'متغيرات',

  // StickersPrint
  'print.title': 'طباعة الملصقات',
  'print.copies': 'نسخ:',
  'print.print': 'طباعة',
  'print.pages': 'صفحات',
  'print.stickers': 'ملصق',
  'print.missing_barcode': 'الباركود مفقود',
  'print.stock': 'المخزون:',
  'print.colors': 'لون',
  'print.sizes': 'مقاس',
  'print.variants': 'متغير',
  'print.page': 'صفحة',

  // Common
  'common.colors_only_desc': 'أضف ألوانًا مختلفة لنفس المنتج (مثل: أحمر، أزرق، أسود)',
  'common.sizes_only_desc': 'أضف مقاسات مختلفة لنفس المنتج (مثل: S، M، L، XL)',
  'common.both_desc': 'أضف مجموعات الألوان والمقاسات (مثل: أحمر/S، أزرق/M)',
  'common.enter_stock': 'أدخل المخزون',
  'common.loading': 'جاري التحميل...',
  'common.error': 'خطأ',
  'common.success': 'نجاح',

  // Invoices - Additional
  'invoices.all_invoices': 'جميع الفواتير',
  'invoices.edit': 'تعديل',
  'invoices.update_success': 'تم تحديث الفاتورة بنجاح',
  'invoices.save_edit': 'حفظ التغييرات',
  'invoices.price_paye': 'المبلغ المدفوع',
  'invoices.balance': 'الرصيد',
  'invoices.add_payment': 'إضافة دفعة',
  'invoices.view': 'عرض',
  'invoices.history': 'السجل',
  'invoices.loading': 'جاري تحميل الفواتير...',
  'invoices.no_invoices': 'لم يتم العثور على فواتير',
  'invoices.add_payment_form': 'تسجيل الدفعة',
  'invoices.payment_amount': 'مبلغ الدفعة',
  'invoices.payment_note': 'ملاحظة',
  'invoices.payment_note_placeholder': 'ملاحظة اختيارية لهذه الدفعة',
  'invoices.cancel': 'إلغاء',
  'invoices.payment_submit': 'حفظ',
  'invoices.payment_saving': 'جاري الحفظ...',
  'invoices.payment_history': 'سجل الدفعات',
  'invoices.no_payments': 'لم يتم تسجيل أي دفعات',
  'invoices.error.payment_amount': 'يرجى إدخال مبلغ دفعة صحيح',
  'invoices.error.payment': 'تعذر تسجيل الدفعة',
  'invoices.payment.success': 'تم تسجيل الدفعة بنجاح',
  'invoices.delete': 'حذف',
  'invoices.delete_confirm': 'هل أنت متأكد من حذف هذه الفاتورة؟',
  'invoices.delete_success': 'تم حذف الفاتورة بنجاح',
  'invoices.deleting': 'جاري الحذف...',
  'invoices.remove_payment': 'إزالة',
  'invoices.payment_removed': 'تم إزالة الدفعة بنجاح',
  'invoices.yes_delete': 'نعم، حذف',
  'invoices.yes_remove': 'نعم، إزالة',

  'nav.charges': 'المصروفات',
  'nav.activity_log': 'سجل النشاطات',

  'charges.title': 'المصروفات',
  'charges.subtitle': 'تتبع جميع المصروفات والمدفوعات',
  'charges.add': 'إضافة مصروف',
  'charges.edit': 'تعديل المصروف',
  'charges.title_label': 'العنوان',
  'charges.amount': 'المبلغ',
  'charges.date': 'التاريخ',
  'charges.notes': 'ملاحظات',
  'charges.actions': 'الإجراءات',
  'charges.loading': 'جاري تحميل المصروفات...',
  'charges.no_charges': 'لم يتم العثور على مصروفات',
  'charges.title_placeholder': 'أدخل عنوان المصروف',
  'charges.amount_placeholder': '0.00',
  'charges.notes_placeholder': 'ملاحظات اختيارية',
  'charges.add_success': 'تمت إضافة المصروف بنجاح',
  'charges.update_success': 'تم تحديث المصروف بنجاح',
  'charges.delete_success': 'تم حذف المصروف بنجاح',
  'charges.error.loading': 'تعذر تحميل المصروفات',
  'charges.error.saving': 'تعذر حفظ المصروف',
  'charges.error.deleting': 'تعذر حذف المصروف',
  'charges.delete_confirm': 'هل أنت متأكد من حذف هذا المصروف؟',
  'charges.total': 'إجمالي المصروفات',
  'charges.from': 'من',
  'charges.to': 'إلى',
  'charges.filter_btn': 'تصفية',
  'charges.clear': 'مسح',
  'charges.saving': 'جاري الحفظ...',

  'activity_log.title': 'سجل النشاطات',
  'activity_log.subtitle': 'تتبع جميع الإجراءات في التطبيق',
  'activity_log.loading': 'جاري تحميل السجل...',
  'activity_log.no_logs': 'لم يتم تسجيل أي نشاط بعد',
  'activity_log.action': 'الإجراء',
  'activity_log.description': 'الوصف',
  'activity_log.user': 'المستخدم',
  'activity_log.date': 'التاريخ',
  'activity_log.details': 'التفاصيل',
  'activity_log.actions.created': 'إنشاء',
  'activity_log.actions.updated': 'تحديث',
  'activity_log.actions.deleted': 'حذف',
  'activity_log.actions.payment': 'دفعة',
  'activity_log.actions.payment_deleted': 'تم إزالة الدفعة',
  'activity_log.actions.stock_augmented': 'تم زيادة المخزون',

  // Nav
  'nav.users': 'المستخدمين',
  'nav.roles': 'الأدوار',

  // Users
  'users.title': 'إدارة المستخدمين',
  'users.subtitle': 'إدارة مستخدمي النظام وأدوارهم',
  'users.add': 'إضافة مستخدم',
  'users.edit': 'تعديل المستخدم',
  'users.name': 'الاسم',
  'users.email': 'البريد الإلكتروني',
  'users.password': 'كلمة المرور',
  'users.password_optional': 'كلمة المرور (اتركه فارغًا للاحتفاظ بها)',
  'users.password_confirmation': 'تأكيد كلمة المرور',
  'users.role': 'الدور',
  'users.actions': 'الإجراءات',
  'users.select_role': 'اختر دورًا',
  'users.no_users': 'لم يتم العثور على مستخدمين',
  'users.name_placeholder': 'أدخل اسم المستخدم',
  'users.email_placeholder': 'أدخل البريد الإلكتروني',
  'users.password_placeholder': 'أدخل كلمة المرور',
  'users.add_success': 'تم إنشاء المستخدم بنجاح',
  'users.update_success': 'تم تحديث المستخدم بنجاح',
  'users.delete_success': 'تم حذف المستخدم بنجاح',
  'users.error.saving': 'تعذر حفظ المستخدم',
  'users.error.deleting': 'تعذر حذف المستخدم',
  'users.delete_confirm': 'هل أنت متأكد من حذف هذا المستخدم؟',
  'users.delete_confirm_btn': 'حذف المستخدم',
  'users.cancel': 'إلغاء',
  'users.saving': 'جاري الحفظ...',
  'users.deleting': 'جاري الحذف...',

  // Permission Groups
  'permission_group.dashboard': 'لوحة القيادة',
  'permission_group.products': 'المنتجات',
  'permission_group.variants': 'المتغيرات',
  'permission_group.invoices': 'الفواتير',
  'permission_group.clients': 'العملاء',
  'permission_group.charges': 'المصروفات',
  'permission_group.activity_logs': 'سجل النشاطات',
  'permission_group.users': 'المستخدمين',
  'permission_group.roles': 'الأدوار',
  'permission_group.scanner': 'الماسح الضوئي',

  // Permissions
  'permissions.dashboard.view': 'عرض لوحة القيادة',
  'permissions.products.view': 'عرض المنتجات',
  'permissions.products.create': 'إنشاء المنتجات',
  'permissions.products.edit': 'تعديل المنتجات',
  'permissions.products.delete': 'حذف المنتجات',
  'permissions.products.stock': 'إدارة المخزون',
  'permissions.variants.view': 'عرض المتغيرات',
  'permissions.variants.create': 'إنشاء المتغيرات',
  'permissions.variants.edit': 'تعديل المتغيرات',
  'permissions.variants.delete': 'حذف المتغيرات',
  'permissions.invoices.view': 'عرض الفواتير',
  'permissions.invoices.create': 'إنشاء الفواتير',
  'permissions.invoices.pay': 'تسجيل المدفوعات',
  'permissions.invoices.edit': 'تعديل الفواتير',
  'permissions.invoices.delete': 'حذف الفواتير',
  'permissions.clients.view': 'عرض العملاء',
  'permissions.charges.view': 'عرض المصروفات',
  'permissions.charges.create': 'إنشاء المصروفات',
  'permissions.charges.edit': 'تعديل المصروفات',
  'permissions.charges.delete': 'حذف المصروفات',
  'permissions.activity_logs.view': 'عرض سجل النشاطات',
  'permissions.users.manage': 'إدارة المستخدمين',
  'permissions.roles.manage': 'إدارة الأدوار',
  'permissions.scan.stock': 'مسح المخزون',

  // Roles
  'roles.title': 'إدارة الأدوار',
  'roles.subtitle': 'إدارة الأدوار والصلاحيات',
  'roles.add': 'إضافة دور',
  'roles.edit': 'تعديل الدور',
  'roles.name': 'اسم الدور',
  'roles.name_placeholder': 'أدخل اسم الدور',
  'roles.permissions': 'الصلاحيات',
  'roles.permissions_count': 'الصلاحيات',
  'roles.users_count': 'المستخدمين',
  'roles.actions': 'الإجراءات',
  'roles.no_roles': 'لم يتم العثور على أدوار',
  'roles.add_success': 'تم إنشاء الدور بنجاح',
  'roles.update_success': 'تم تحديث الدور بنجاح',
  'roles.delete_success': 'تم حذف الدور بنجاح',
  'roles.error.saving': 'تعذر حفظ الدور',
  'roles.error.deleting': 'تعذر حذف الدور',
  'roles.delete_confirm': 'هل أنت متأكد من حذف هذا الدور؟',
  'roles.delete_confirm_btn': 'حذف الدور',
  'roles.cancel': 'إلغاء',
  'roles.saving': 'جاري الحفظ...',
  'roles.deleting': 'جاري الحذف...',
}

export default ar
